/* eslint-disable react-hooks/exhaustive-deps */
import { ChevronDown, ChevronUp, Search, RotateCw } from 'lucide-react'
import moment from 'moment'
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  OverlayTrigger,
  Popover,
  Row,
  Table
} from 'react-bootstrap'
import { Loader } from 'react-bootstrap-typeahead'
import { Link, useLocation } from 'react-router-dom'
import {
  BadgeStatusCOA,
  BadgeStatusPrLists
} from '../../../components/atoms/StatusLabel'
import TableAction from '../../../components/atoms/Table/TableAction'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import InputDatePicker from '../../../components/Input/DatePicker/InputDatePicker'
import ModalAddSelectStagingArea from '../../../components/modal/ReceiveML/ModalAddSelectStagingArea'
import api from '../../../config/AxiosInstance'
import { convertDateWithTime } from '../../../helpers/constants'
import * as Common from '../../../utils/Common'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

function Index() {
  const { state } = useLocation()
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [inboundId, setInboundId] = useState(null)
  const [modalStagingArea, setModalStagingArea] = useState(false)
  const [receiveWarehouses, setReceiveWarehouses] = useState([])
  const [selectWarehouseId, setSelectWarehouseId] = useState('')
  const [filter, setFilter] = useState({
    ml_draft: state?.ml_draft || '',
    receiver_warehouse: state?.receiver_warehouse || '',
    start_date: state?.start_date || '',
    end_date: state?.end_date || ''
  })
  const [debouncedMlDraft, setDebouncedMlDraft] = useState(filter.ml_draft)

  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedMlDraft(filter.ml_draft)
      if (filter.ml_draft !== debouncedMlDraft) {
        setMeta((prev) => ({ ...prev, current_page: 1 }))
      }
    }, 1000)

    return () => {
      clearTimeout(handler)
    }
  }, [filter.ml_draft])

  const handleChangeValueFilter = (e) => {
    const { name, value } = e.target
    const newFilter = { ...filter, [name]: value }

    if (name === 'start_date' && value && filter.end_date) {
      if (moment(value) > moment(filter.end_date)) {
        newFilter.end_date = value
      }
    }

    if (name === 'end_date' && value && filter.start_date) {
      if (moment(value) < moment(filter.start_date)) {
        newFilter.start_date = value
      }
    }

    setFilter(newFilter)
  }

  const handleResetFilter = () => {
    setFilter({
      ml_draft: '',
      receiver_warehouse: '',
      start_date: '',
      end_date: ''
    })
    setDebouncedMlDraft('')
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: 1
    }))
  }

  const handleOnChangeMeta = (e) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: parseInt(e.target.value, 10),
      current_page: 1
    }))
  }

  const handlePageChange = (data) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: data.selected + 1
    }))
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    if (
      (filter.start_date && !filter.end_date) ||
      (!filter.start_date && filter.end_date)
    ) {
      return
    }

    fetchMLLists()
  }, [
    meta.per_page,
    meta.current_page,
    debouncedMlDraft,
    filter.receiver_warehouse,
    filter.start_date,
    filter.end_date
  ])

  useEffect(() => {
    fetchReceiverWarehouse()
  }, [])

  const fetchReceiverWarehouse = async () => {
    try {
      const response = await api.get(
        '/master/warehouses/all?is_parent=true&forUser=1'
      )
      const { data } = response
      if (data.success) {
        setReceiveWarehouses(data.data)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const fetchMLLists = async () => {
    try {
      setLoading(true)
      const params = {
        ...filter,
        ml_draft: debouncedMlDraft,
        per_page: meta.per_page,
        page: meta.current_page
      }
      const res = await api.get('/inbound/ml-draft', {
        params: params
      })
      const { data } = res
      if (data.success) {
        setData(data.data)
        setMeta(data.metadata)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading(false)
    }
  }

  const handleModalStagingArea = (inboundId, warehouseId) => {
    setModalStagingArea(true)
    setInboundId(inboundId)
    setSelectWarehouseId(warehouseId)
  }

  return (
    <>
      <Container fluid className="px-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <h3 style={headerTitleStyle}>ML Draft List</h3>
          </Col>
          <Col className="text-end">
            <Button
              variant="light"
              className="text-secondary fw-bold rounded px-3 border"
              onClick={() => handleResetFilter()}
              style={{ fontSize: '0.85rem' }}
            >
              <RotateCw size={14} className="me-2" />
              Reset Filters
            </Button>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row className="g-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>#ML DRAFT</Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={16} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    id="ml_draft"
                    name="ml_draft"
                    value={filter.ml_draft}
                    onChange={(e) => handleChangeValueFilter(e)}
                    placeholder="Search ML Draft..."
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="sjdelivend">
                <Form.Label style={labelStyle}>RECEIVER WAREHOUSE</Form.Label>
                <Form.Select
                  aria-label="Select Receiver Warehouse"
                  name="receiver_warehouse"
                  id="receiver_warehouse"
                  value={filter.receiver_warehouse}
                  onChange={(e) => {
                    handleChangeValueFilter(e)
                    setMeta((prev) => ({ ...prev, current_page: 1 }))
                  }}
                  style={FormControlStyle}
                >
                  <option value="">All Warehouses</option>
                  {receiveWarehouses?.map((warehouse) => (
                    <option key={warehouse.id} value={warehouse.id}>
                      {warehouse.warehouse_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Start Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={filter?.start_date}
                    onChange={(date) => {
                      handleChangeValueFilter({
                        target: {
                          name: 'start_date',
                          value: date ? moment(date).format('YYYY-MM-DD') : ''
                        }
                      })
                      setMeta((prev) => ({ ...prev, current_page: 1 }))
                    }}
                    maxDate={filter.end_date ? new Date(filter.end_date) : null}
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>End Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={filter?.end_date}
                    onChange={(date) => {
                      handleChangeValueFilter({
                        target: {
                          name: 'end_date',
                          value: date ? moment(date).format('YYYY-MM-DD') : ''
                        }
                      })
                      setMeta((prev) => ({ ...prev, current_page: 1 }))
                    }}
                    minDate={
                      filter.start_date ? new Date(filter.start_date) : null
                    }
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Card>

        <Row className="mt-3">
          <Col md={12}>
            <ReceiveTable
              data={data}
              meta={meta}
              handleOnChangeMeta={handleOnChangeMeta}
              handlePageChange={handlePageChange}
              loading={loading}
              handleModalStagingArea={handleModalStagingArea}
              filter={filter}
              modalStagingArea={modalStagingArea}
            />
          </Col>
        </Row>
        <ModalAddSelectStagingArea
          show={modalStagingArea}
          onHide={() => {
            setModalStagingArea(false)
            setSelectWarehouseId('')
            setInboundId(null)
          }}
          warehouseId={selectWarehouseId}
          inboundId={inboundId}
          refreshData={() => fetchMLLists()}
        />
      </Container>
    </>
  )
}
const ReceiveTable = ({
  data,
  meta,
  handleOnChangeMeta,
  handlePageChange,
  loading,
  handleModalStagingArea,
  filter,
  modalStagingArea
}) => {
  const statusTextMapping = {
    unassigned: 'unassigned',
    waiting_rnr: 'waiting rnr',
    receiving_progress: 'receiving progress',
    rnr: 'receiving progress',
    waiting_om: 'waiting om',
    request_pnp: 'waiting om',
    waiting_pnp: 'waiting pnp',
    pnp: 'put away',
    put_away: 'put away',
    done: 'done',
    revised: 'waiting rnr'
  }
  const statusCoaMapping = {
    unchecked: 'unchecked',
    match: 'match',
    not_match: 'not match'
  }
  return (
    <Table
      hover
      responsive
      className="shadow-sm mb-5 bg-white"
      style={{
        borderRadius: '12px',
        overflow: 'hidden',
        fontSize: '0.9rem'
      }}
    >
      <thead style={{ backgroundColor: '#f8f9fa' }}>
        <tr>
          <th className="p-2 align-middle" style={tableHeaderStyle}>
            Created
          </th>
          <th className="p-2 align-middle" style={tableHeaderStyle}>
            TR
          </th>
          <th className="p-2 align-middle" style={tableHeaderStyle}>
            #ML Draft
          </th>
          <th className="p-2 align-middle" style={tableHeaderStyle}>
            Target Warehouse
          </th>
          <th className="p-2 align-middle text-end" style={tableHeaderStyle}>
            Staging Area
          </th>
          <th className="p-2 align-middle text-end" style={tableHeaderStyle}>
            Status COA
          </th>
          <th className="p-2 align-middle text-end" style={tableHeaderStyle}>
            Status
          </th>
          <th className="p-2 align-middle text-end" style={tableHeaderStyle}>
            Action
          </th>
        </tr>
      </thead>
      <tbody style={{ fontSize: '12px' }}>
        {loading && (
          <tr>
            <td colSpan={8} className="text-center p-5">
              <Loader />
            </td>
          </tr>
        )}
        {!loading && !data.length && (
          <tr>
            <td colSpan={8} className="text-center fw-bold p-5 text-muted">
              No Data Found
            </td>
          </tr>
        )}
        {!loading &&
          data.length > 0 &&
          data.map((item, i) => (
            <tr key={item.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
              <td className="p-2 align-middle text-muted">
                {convertDateWithTime(item?.createdAt)}
              </td>
              <td className="p-2 align-middle">{item?.tr_code || '-'}</td>
              <td className="p-2 align-middle fw-semibold text-primary">
                {item?.ml_draft}
              </td>
              <td className="p-2 align-middle text-muted">
                {item?.target_warehouse}
              </td>
              <td className="p-2 align-middle text-end">
                {item?.inbounds?.stagings.length > 0 && (
                  <>
                    <OverlayTrigger
                      trigger={['hover', 'click']}
                      key={'bottom'}
                      placement={'bottom'}
                      overlay={
                        <Popover id={`popover-positioned-bottom`}>
                          <Popover.Body>
                            <p>
                              {' '}
                              {item?.inbounds?.stagings
                                .map((staging) => staging.name)
                                .join(', ')}
                            </p>
                          </Popover.Body>
                        </Popover>
                      }
                    >
                      <div className="d-flex flex-row justify-content-end">
                        <p
                          style={{ cursor: 'pointer', maxWidth: '80%' }}
                          className="text-truncate mb-0"
                        >
                          {item?.inbounds?.stagings
                            .map((staging) => staging.name)
                            .join(', ')}
                        </p>
                      </div>
                    </OverlayTrigger>
                  </>
                )}
                {!item?.inbounds?.stagings.length && (
                  <>
                    <div
                      className="d-flex flex-row gap-2 justify-content-end cursor-pointer text-muted"
                      role="button"
                      onClick={() =>
                        handleModalStagingArea(
                          item?.inbounds?.id,
                          item?.target_warehouse
                        )
                      }
                    >
                      <span>Staging Area</span>
                      {modalStagingArea ? (
                        <ChevronUp
                          size={14}
                          className="fa-flip-horizontal ml-2 mt-1"
                        />
                      ) : (
                        <ChevronDown
                          size={14}
                          className="fa-flip-horizontal ml-2 mt-1"
                        />
                      )}
                    </div>
                  </>
                )}
              </td>
              <td className="p-2 align-middle text-end">
                <BadgeStatusCOA
                  text={statusCoaMapping[item?.coa_status] || 'unchecked'}
                />
              </td>
              <td className="p-2 align-middle text-end">
                <BadgeStatusPrLists
                  text={statusTextMapping[item?.inbounds?.status || 'done']}
                />
              </td>
              <td className="p-2 align-middle text-end">
                <TableAction>
                  <Link to={`/inbound/ml/detail/${item.id}`} state={filter}>
                    <Button
                      variant="light"
                      className="btn-sm border rounded text-secondary"
                      style={{ width: '32px', height: '32px', padding: 0 }}
                    >
                      <Search size={13} />
                    </Button>
                  </Link>
                </TableAction>
              </td>
            </tr>
          ))}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={8} className="p-3 border-top-0">
            <TablePagination
              meta={meta}
              handleOnChangeMeta={handleOnChangeMeta}
              handlePageChange={handlePageChange}
            />
          </td>
        </tr>
      </tfoot>
    </Table>
  )
}

export default Index
